import {auth} from "./drivers/auth";
import {general} from "./drivers/general";
import {fieldTasks} from "./drivers/fieldTasks";
import {dashboard} from "./drivers/dashboard";
import {elements} from "./drivers/elements";
import {elementClassification} from "./drivers/element-classification";
import {boards} from "./drivers/boards";
import {audit} from "./drivers/audit";
import {tracking} from "./drivers/tracking";
import {media} from "./drivers/media";

export const Api = {
  auth,
  general,
  fieldTasks,
  dashboard,
  elements,
  elementClassification,
  boards,
  audit,
  tracking,
  media,
};
